import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ChatiaDialogActions from "../ChatiaDialogActions";
import { CloseXIcon } from "../ChatiaIcons";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => {
  const isDark = theme.mode === "dark" || theme.palette?.type === "dark";
  return {
    paper: {
      borderRadius: 14,
      background: isDark ? "#121212" : "#ffffff",
      color: isDark ? "#e9edef" : "#111b21",
      border: isDark
        ? "1px solid rgba(255,255,255,0.08)"
        : "1px solid rgba(0,0,0,0.06)",
      overflow: "hidden",
      "& .MuiOutlinedInput-root": {
        borderRadius: 12,
      },
      "& .MuiDialogContent-root": {
        background: isDark ? "#121212" : "#ffffff",
        color: isDark ? "#e9edef" : "#111b21",
      },
      "& .MuiDialogActions-root": {
        background: isDark ? "#121212" : "#ffffff",
      },
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "14px 16px",
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText || "#ffffff",
    },
    headerTitle: {
      fontWeight: 600,
      fontSize: 15,
      color: "inherit",
    },
    closeButton: {
      padding: 4,
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      color: "#ffffff",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.18)",
        color: "#ffe5e5",
      },
    },
    content: {
      padding: theme.spacing(2),
    },
  };
});

export default function ContactNotesEditModal({ open, onClose, note, onSave }) {
  const classes = useStyles();
  const [text, setText] = useState(note || "");

  useEffect(() => {
    if (open) setText(note || "");
  }, [open, note]);

  const handleSave = () => {
    if (typeof onSave === "function") onSave(text);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: classes.paper }}
    >
      <div className={classes.header}>
        <Typography className={classes.headerTitle}>
          {i18n.t("ticketOptionsMenu.appointmentsModal.editTitle") ||
            "Editar observação"}
        </Typography>
        <IconButton
          size="small"
          onClick={onClose}
          className={classes.closeButton}
        >
          <CloseXIcon style={{ fontSize: 16 }} />
        </IconButton>
      </div>
      <DialogContent className={classes.content} dividers>
        <TextField
          label={i18n.t("ticketOptionsMenu.appointmentsModal.textarea") || "Observação"}
          fullWidth
          multiline
          minRows={4}
          value={text}
          onChange={(e) => setText(e.target.value)}
          variant="outlined"
        />
      </DialogContent>
      <ChatiaDialogActions
        type="button"
        onClick={handleSave}
        saveText={i18n.t("contactModal.buttons.okEdit") || "Salvar"}
      />
    </Dialog>
  );
}
